/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const showSitePasses = (
    facilityId,
    facilitiesUsingSitePassIntegration = {},
    newSitePassIntegrationEnabled = false
) => {
    if (!facilityId) {
        return false;
    }

    const defaultValue = !!facilitiesUsingSitePassIntegration?.default;

    const includeFacilityId =
        !!facilitiesUsingSitePassIntegration?.hasOwnProperty(facilityId);

    if (!includeFacilityId) {
        if (newSitePassIntegrationEnabled) {
            return true;
        }
        return defaultValue;
    }

    return !!facilitiesUsingSitePassIntegration?.[facilityId];
};

export const showGuestCheckout = (facilityId, facilitiesUsingGuestCheckout = {}) => {
    if (!facilityId) {
        return false;
    }

    if (facilitiesUsingGuestCheckout?.['disable-timed-entry-locations']) {
        return false;
    }

    const defaultValue = !!facilitiesUsingGuestCheckout?.default;
    const includeFacilityId = !!facilitiesUsingGuestCheckout?.hasOwnProperty(facilityId);

    if (!includeFacilityId) {
        return defaultValue;
    }

    return !!facilitiesUsingGuestCheckout?.[facilityId];
};

export const showNewSitePassLayout = (sitePassUiRevamp = false) => {
    return !!sitePassUiRevamp;
};

export const showAvailabilityNotification = (facilityId, ticAvailNotifications = {}) => {
    if (!facilityId) {
        return false;
    }

    const defaultValue = !!ticAvailNotifications?.default;
    const includeFacilityId = !!ticAvailNotifications?.hasOwnProperty(facilityId);

    if (!includeFacilityId) {
        return defaultValue;
    }

    return !!ticAvailNotifications?.[facilityId];
};

export const showNoTicketRequired = (
    facilityId,
    facilitiesUsingNoTicketRequired = {}
) => {
    if (!facilityId) {
        return false;
    }

    const defaultValue = !!facilitiesUsingNoTicketRequired?.default;
    const includeFacilityId =
        !!facilitiesUsingNoTicketRequired?.hasOwnProperty(facilityId);

    if (!includeFacilityId) {
        return defaultValue;
    }

    return !!facilitiesUsingNoTicketRequired?.[facilityId];
};
